import { CircularProgress, Box, Typography } from "@material-ui/core";

const PaymentsLoading = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={4}
      minHeight="200px"
    >
      <CircularProgress size={40} color="primary" />
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginTop: "16px" }}
      >
        Cargando datos de pagos...
      </Typography>
    </Box>
  );
};

export default PaymentsLoading;
